module.exports = __webpack_public_path__ + "media/images/landing/scroll_arrow_dark-50e082d0ccc2445e491b030af6cb88e7.png";